import { markNotificationAsRead } from './api';

export const markNotificationAsReadMutation = () => ({
  mutationFn: (id: number) => markNotificationAsRead(id),
});

